import { render } from "./placeholderImg.vue?vue&type=template&id=366435cf&ts=true"
import script from "./placeholderImg.vue?vue&type=script&lang=ts"
export * from "./placeholderImg.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__